import React, { ReactNode } from 'react';
import { ThemeProvider as FeelixThemeProvider } from '@myob/myob-widgets';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { FEELIX_THEMES } from '../../constants';

interface ThemeProviderProps {
  children?: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { theme } = useSessionContext();

  const feelixTheme = [FEELIX_THEMES.PARTNER, FEELIX_THEMES.COMMON].includes(theme) ? FEELIX_THEMES.MODERN : theme;
  
  return (
    <FeelixThemeProvider theme={feelixTheme}>
      {children}
    </FeelixThemeProvider>
  );
};
